import Vue from 'vue';

export const ApckWidgetCounter = /*#__PURE__*/ Vue.extend({
    props: {
        title: {
            type: String,
            default: null
        },
        icon: {
            type: String,
            default: null
        },
        data: {
            type: Number,
            default: 0
        },
        noBorder: {
            type: Boolean,
            default: false
        },
        backgroundClass: {
            type: String,
            default: null
        },
        iconClass: {
            type: String,
            default: null
        },
        counterClass: {
            type: String,
            default: null
        },
        actionUrl: {
            type: String,
            default: null
        }
    },
    data: function() {
        return {};
    },
    methods: {
        open() {
            if (this.actionUrl) {
                window.open(this.actionUrl, '_blank').focus();
            }
        }
    },
    template: `
        <div
            v-bind:class="[noBorder ? 'no-border' : '', 'count-panel', backgroundClass]"
            @click="open"
        >

            <i v-if="icon" v-bind:class="['icon', 'fa', icon, iconClass]"></i>

            <div v-if="title" v-bind:class="['panel-title']">
                {{ title }}
            </div>

            <div v-bind:class="[icon ? '' : 'no-icon', 'counter', counterClass]">
                {{ data }}
            </div>
            
        </div>
    `
});